import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import throttle from "../../utils/throttle";

var useSize = function useSize() {
  var elementObserverRef = useRef();
  var handleResizeRef = useRef();

  var _useState = useState({
    height: 0,
    width: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  var ref = useCallback(function (element) {
    if (!element) {
      var _handleResize = handleResizeRef.current;
      window.removeEventListener('resize', _handleResize);
      elementObserverRef.current.disconnect();
      return;
    }

    var handleResize = throttle(function () {
      return setSize({
        height: element.offsetHeight,
        width: element.offsetWidth
      });
    });
    handleResize();
    window.addEventListener('resize', handleResize);

    if (!elementObserverRef.current) {
      var elementObserver = new ResizeObserver(handleResize);
      elementObserver.observe(element);
      elementObserverRef.current = elementObserver;
    }

    handleResizeRef.current = handleResize;
  }, []);
  return _objectSpread(_objectSpread({}, size), {}, {
    ref: ref
  });
};

export default useSize;